module.exports = __webpack_public_path__ + "img/svg/crossplay.3a422da4ba8b1245375eaa5a144ead62.svg";